<template>
  <BgImageLayout :height="topBarHeight">
    <template #title>
      <slot name="title">{{ title }}</slot>
    </template>

    <div :class="{ 'has-header': hasHeaderSlot }" class="wrapper">
      <slot name="header" />

      <slot name="content">
        <div class="content">
          <slot name="content-loading">
            <div v-if="loading" class="spinner-wrapper">
              <q-spinner color="primary" size="2em" />
            </div>
          </slot>

          <slot name="content-no-data">
            <div v-if="!loading && !dataLength" class="no-data">
              <NoData />
              <span>No data yet</span>
            </div>
          </slot>

          <slot name="content-data" />
        </div>
      </slot>
    </div>
  </BgImageLayout>
</template>

<script>
// Components
import NoData from '@/reusable/svg-icons/NoData'

export default {
  components: {
    NoData
  },

  props: {
    topBarHeight: {
      type: String,
      default: '340px'
    },

    title: String,

    noDataTitle: {
      type: String,
      default: 'No data yet'
    },

    loading: Boolean,
    dataLength: Number
  },

  computed: {
    hasHeaderSlot() {
      return !!this.$slots.header
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins'

.wrapper {
  height: calc(100vh - 100px) !important
  box-shadow 0 1px 5px rgba(0,0,0,0.2), 0 2px 2px rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12)
  border-radius 4px
  background #fff
  display grid
  padding 25px

  &.has-header {
    grid-template-rows 60px 1fr
  }

  styledScrollFor('.content');

  .content {
    position relative
    background #e8ecf7
    padding 15px
    border-radius 5px
    overflow auto

    > .spinner-wrapper {
      height 100%
      display flex
      justify-content center
      align-items center
    }

    > .no-data {
      display grid
      height 100%
      justify-content center
      align-items center
      align-content center
      justify-items center

      > span {
        font-size 1rem
        opacity 0
        animation: fadeInWithDelay 0.5s ease-in 1s forwards;
      }
    }
  }
}

@keyframes fadeInWithDelay {
  to {
    opacity 1
  }
}
</style>
